module.exports = __webpack_public_path__ + "assets/img/29_272.348f41b0.jpg";